// @flow

import TagManager from 'react-gtm-module';
import type { DataLayer } from '../store/types';
import config from 'config/app.config';
import * as Sentry from '@sentry/react';
import { getCookie } from './CommonUtils';

export const defaultDataLayer = {
  type: 'CONTENT',
  category: '',
  sub_category: '',
  page: `${window.location.pathname}${window.location.search}`,
  step: '',
  landing: '0',
  visit_affiliate: '',
  visit_info1: '',
  visit_info2: '',
  visit_info3: '',
  visit_info4: '',
  visit_info5: '',
  creation_affiliate: '',
  creation_info1: '',
  creation_info2: '',
  creation_info3: '',
  creation_info4: '',
  creation_info5: '',
  deposit_affiliate: '',
  deposit_info1: '',
  deposit_info2: '',
  deposit_info3: '',
  deposit_info4: '',
  deposit_info5: '',
  custom1: '',
  custom2: window.config.IS_FIRST_VISIT ? 'Y' : 'N',
  custom3: '',
  custom4: '',
  custom5: '',
  uu: '',
  at: '',
  fd: 'N',
  is_xp: global.navigator.userAgent.includes('Windows NT 5.1') ? '1' : '0',
  cookie_tier: '1',
  cookie_analytics: '1',
  language: config.lang !== config.license ? config.lang : undefined,
  license: config.license,
};

export const isAuthorized = () => {
  const winacookie = getCookie(config.analytics.cookie.name);
  if (!winacookie) {
    return false;
  }

  let shouldAuthorized = false;
  const elements = winacookie.split('!');
  for (const element of elements) {
    const [key, value] = element.split('=');
    if (key === config.analytics.cookie.key) {
      shouldAuthorized = value !== 'wait' && value !== 'false';
      break;
    }
  }

  return shouldAuthorized;
};

export const init = () => {
  const tagManagerArgs = {
    gtmId: config.tagManager.gtmId,
    dataLayer: defaultDataLayer,
  };

  TagManager.initialize(tagManagerArgs);
};

export const sendDataLayer = (dataLayer: DataLayer) => {
  if (!isAuthorized()) return;

  try {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        ...dataLayer,
      },
    });
  } catch (e) {
    Sentry.captureException(e);
  }
};

export default {
  isAuthorized,
  init,
  sendDataLayer,
};
